// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__22T2M","footer":"ModalFilter_footer__1IRmV"};